import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';

import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { dashboardConfig } from './config';

const DashboardNavigator = () => {
  const DashboardStack = createStackNavigator();

  return (
    <DashboardStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {dashboardConfig.map(({ Component, name }) => (
        <DashboardStack.Screen key={name} name={name} component={Component} />
      ))}
    </DashboardStack.Navigator>
  );
};

export { DashboardNavigator };
